module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M2.01 0C.904 0 0 1.021 0 2.151v22.07c0 1.13.905 1.914 2.01 1.914h2.01v4.777c0 1.134.812 1.325 1.813.834l10.812-5.611h13.51c1.106 0 2.01-.784 2.01-1.914V2.151c0-1.13-.905-2.151-2.01-2.151H2.009zm22.115 11.057c0 .555-.45 1.005-1.005 1.005H9.047c-.555 0-1.005-.45-1.005-1.005v-2.01c0-.555.45-1.005 1.005-1.005H23.12c.555 0 1.005.45 1.005 1.005v2.01zm0 6.032c0 .555-.45 1.005-1.005 1.005H9.047c-.555 0-1.005-.45-1.005-1.005v-2.01c0-.555.45-1.005 1.005-1.005H23.12c.555 0 1.005.45 1.005 1.005v2.01z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/post-comment-2.js
// module id = 1353
// module chunks = 14